export default {
    undefined: '',
    Username: 'Username',
    Password: 'Password',
    'Log In': 'Log In',
    'Invalid username and password combination':
        'Invalid username and password combination',
    'User not found': 'User not found',
    'An unexpected error has occurred trying to get the companies, please try again':
        'An unexpected error has occurred trying to get the companies, please try again',
    'An unexpected error has occurred, please try again':
        'An unexpected error has occurred, please try again',
    Search: 'Search',
    'Unexpected warning message format': 'Unexpected warning message format',
    'Enter your password': 'Enter your password',
    'Username is required': 'Username is required',
    'Password is required': 'Password is required',
    'Log out': 'Log out',
    'Select a company': 'Select a company',
    Home: 'Home',
    Administration: 'Administration',
    Settings: 'Settings',
    Subscription: 'Subscription',
    Users: 'Users',
    List: 'List',
    Create: 'Create',
    Manage: 'Manage',
    Agents: 'Agents',
    Clients: 'Clients',
    Cities: 'Cities',
    Places: 'Places',
    Regions: 'Regions',
    States: 'States',
    Countries: 'Countries',
    Packages: 'Packages',
    Plan: 'Plan',
    Payments: 'Payments',
    Status: 'Status',
    'Paypal data': 'Paypal data',
    Actions: 'Actions',
    Columns: 'Columns',
    Number: 'Number',
    Date: 'Date',
    Receiver: 'Consignee',
    Agency: 'Agency',
    Dimensions: 'Dimensions',
    Weight: 'Weight',
    Volume: 'Volumen',
    Description: 'Description',
    Value: 'Value',
    'Total cargo value': 'Total cargo value',
    'Submitted by connect': 'Submitted by connect',
    Voided: 'Voided',
    Repackaged: 'Repackaged',
    Received: 'Received',
    'Received by': 'Received by',
    New: 'New',
    Details: 'Details',
    Attachments: 'Attachments',
    Location: 'Location',
    Shipper: 'Shipper',
    Consignee: 'Consignee',
    Creation: 'Creation',
    Pieces: 'Pieces',
    Type: 'Type',
    'Items per page': 'Items per page',
    Loading: 'Loading',
    'Try again': 'Try again',
    'No available data': 'No available data',
    'Selected for': 'Selected for',
    Shipping: 'Shipping',
    'Vol. Weight': 'Vol. Weight',
    Carrier: 'Carrier',
    Remove: 'Remove',
    Edit: 'Edit',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    Procesado: 'Processed',
    'Por procesar': 'Unprocessed',
    Aéreo: 'Air',
    Marítimo: 'Ocean',
    Terrestre: 'Ground',
    Caja: 'Box',
    Ninguna: 'None',
    Select: 'Select',
    All: 'All',
    'Shipping type': 'Shipping type',
    Void: 'Void',
    'No void': 'No void',
    From: 'From',
    To: 'To',
    User: 'User',
    Agent: 'Agent',
    'form.errors':
        'No errors found | One detail detected. Please review and correct it. | This form contains {count} details for being reviewed and corrected.',
    'Create status': 'Create status',
    Finish: 'Finish',
    'Print label': 'Print label',
    'Custom Labels': 'Custom Labels',
    'Send by email': 'Send by email',
    'Send by message': 'Send by message',
    Print: 'Print',
    General: 'General',
    'Send email to shipper': 'Send email to shipper',
    'Send email to consignee': 'Send email to consignee',
    'Whatsapp notification to shipper': 'Whatsapp notification to shipper',
    'Whatsapp notification to consignee': 'Whatsapp notification to consignee',
    'Package type': 'Package type',
    Length: 'Length',
    Width: 'Width',
    Height: 'Height',
    Documents: 'Documents',
    Document: 'Document',
    Images: 'Images',
    Name: 'Name',
    State: 'State',
    Country: 'Country',
    Latitude: 'Latitude',
    Longitude: 'Longitude',
    'Delete status': 'Delete status',
    DELIVERED: 'DELIVERED',
    'Warehouse Receipt': 'Warehouse Receipt',
    'Warehouse Receipts': 'Warehouse Receipts',
    'There are no pictures to show in this view':
        'There are no pictures to show in this view',
    Save: 'Save',
    Invoice: 'Invoice',
    Consolidated: 'Consolidated',
    Totals: 'Totals',
    WVol: 'WVol',
    Instructions: 'Instructions',
    Warehouses: 'Warehouses',
    'Origin number': 'Origin number',
    'Destination number': 'Destination number',
    'Shipper email': 'Shipper email',
    'Consignee email': 'Consignee email',
    'Delivery list': 'Delivery list',
    Delivery: 'Delivery',
    'Destination Country': 'Destination Country',
    Repacked: 'Repacked',
    Normal: 'Normal',
    Destination: 'Destination',
    Tracking: 'Tracking',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Reason: 'Reason',
    'Reason is required with at least {min} characters':
        'Reason is required with at least {min} characters',
    Rejection: 'Rejection',
    'Rejection Date': 'Rejection Date',
    'Rejection Reason': 'Rejection Reason',
    Undo: 'Undo',
    'Some packages could not be added to the warehouse':
        'Some packages could not be added to the warehouse',
    'Confirm Remove Package':
        'Would you like to proceed with the removal of package number {packagenumber}?',
    'Confirm Remove Warehouse':
        'Would you like to proceed with the removal of warehouse number {warehousenumber}?',
    'Cannot Remove Package':
        'Cannot delete package {packagenumber}; it is processed in {processedIn}',
    'Cannot Remove Warehouse':
        'Cannot delete warehouse {warehousenumber}; it already was cancelled',
    'Cannot Remove Processed Warehouse':
        'Cannot delete warehouse {warehousenumber}; it already was processed',
    'Cannot Reject Repack':
        'Cannot reject repacking request {repackingNumber}; it already was processed or rejected',
    'Confirm Reject Request':
        'Would you like to proceed with the reject of repacking request number {repackingNumber}?',
    'Multiple Remove Item':
        'Would you like to proceed with the removal of the item identified as {itemIdentifier}?',
    Package: 'Package | Packages',
    max_resolution_error:
        'Image dimensions should be {width}x{height} or smaller.',
    Close: 'Close',
    Ending: 'Ending',
    Company: 'Company',
    'State Status': 'State',
    Processed: 'Processed',
    Unprocessed: 'Unprocessed',
    'Send email': 'Send email',
    'Confirm Send Email':
        'A message of the {entity} {number} will be sent, select the recipient:',
    Other: 'Other',
    'Enter Email': 'Enter mail',
    Send: 'Send',
    Sent: 'Sent',
    'Could Not': 'Could not {action}',
    'Action Successfully': '{action} successfully!',
    'Error en los datos': 'Data error',
    'Load Units': 'Load Units',
    Shipment: 'Shipment',
    'Create package': 'Create package',
    'Edit package': 'Edit package',
    Lastname: 'Lastname',
    Email: 'Email',
    Address: 'Address',
    City: 'City',
    Phone: 'Phone',
    'Could Not Remove': 'Could not remove',
    Yes: 'Yes',
    'Removing Package': 'Removing package',
    No: 'No',
    Ok: 'OK',
    'No puede ser editado': 'Cannot be edited',
    Prepack: 'Prepack',
    Prepacks: 'Prepacks',
    'Repackaging type': 'Repackaging type',
    Code: 'Code',
    'Upload image': 'Upload image',
    'Choose image': 'Choose image',
    Upload: 'Upload',
    'New Status': 'New Status',
    Comment: 'Comment',
    External: 'External',
    'New Status for': 'New Status for',
    'Please, Try later': 'Please, Try later',
    'Processed In': 'Processed In',
    Measure: 'Measure | Measures',
    Origin: 'Origin',
    'Sending Company': 'Sending company',
    Invoices: 'Invoices',
    'Max Amount': 'Max. amount',
    'Min Amount': 'Min. amount',
    Pending: 'Pending',
    Paid: 'Paid',
    Unpaid: 'Unpaid',
    'Date Type': 'Date type',
    'Creation Date': 'Creation Date',
    'Due Date': 'Due date',
    Amount: 'Amount',
    'Days Overdude': 'Days overdude',
    Shipments: 'Shipments',
    'Customer Address': 'Customer address',
    Customer: 'Customer | Customers',
    'Id Document': 'Id Document',
    Tax: 'Tax',
    Taxes: 'Taxes',
    'Payment Type': 'Payment type',
    'Add Payment': 'Add payment',
    Summary: 'Summary',
    'Total Payment': 'Total Payment',
    'Applied to Invoices': 'Applied to Invoices',
    'Credit Balance': 'Credit Balance',
    'Applied to': 'Applied to',
    'Invoices Applied': 'Invoices Applied',
    invoice: 'invoice',
    invoices: 'invoices',
    label: 'Labels',
    status: 'Status',
    Sobre: 'Envelope',
    'error.status':
        'The items ({errorNumbers}) have already been sent, they cannot receive any further status',
    Currency: 'Currency',
    'Payment Link': 'Payment link',
    Delivered: 'Delivered',
    'Last Name': 'Last Name',
    'Customer Create': 'Customer Create',
    'Phone No.': 'Phone No.',
    'Mobile Phone No.': 'Mobile Phone No.',
    Mobile: 'Mobile',
    'Zip Code': 'Zip Code',
    Export: 'Export',
    Filters: 'Filters',
    'Download excel': 'Download excel',
    'Preview PDF': 'Preview PDF',
    'Consolidated Type': 'Consolidated Type',
    'Consolidated Types': 'Consolidated types',
    Refrigerado: 'Cooler',
    Express: 'Express',
    'Super Rapido': 'Super fast',
    Maritimo: 'Maritime 45 - 60',
    'Consolidated Status': 'Consolidated status',
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    DELIVERY: 'DELIVERY',
    Supplier: 'Supplier',
    'Country From': 'Country from',
    'Country To': 'Country to',
    Sender: 'Sender',
    'Total Pending': 'Total pending',
    Office: 'Office',
    'Bill Total': 'Total Bill',
    'Total Bills Paid': 'Total bills paid',
    'Total Profit': 'Total profit',
    Quantity: 'Quantity',
    'Total Paid': 'Total paid',
    'Total Due': 'Total due',
    'Total Expenses': 'Total expenses',
    Processor: 'Processor',
    'Pickup Date': 'Pickup date',
    'Pickup Hour': 'Pickup hour',
    'Paid Type': 'Paid type',
    'Pickup Address': 'Pickup address',
    Pickup: 'Pickup',
    Pickups: 'Pickups',
    'Delivery Address': 'Delivery address',
    'Operation Type': 'Operation type',
    'Create Packages': 'Create packages',
    'Weight (Lb)': 'Weight (Lb)',
    'Volume (CF)': 'Volumen (CF)',
    Wvol: 'Pvol',
    Note: 'Note',
    'Origin country': 'Origin country',
    'Number Invoices': 'Number invoices',
    'Total Amount': 'Total Amount',
    'Outstanding Amount': 'Outstanding amount',
    'Estimated Cost': 'Estimated cost',
    'Estimated Profit': 'Estimated profit',
    Measures: 'Measures',
    Condition: 'Condition',
    Alerts: 'Alerts',
    'Delivery List': 'Delivery List',
    'Delivery Lists': 'Delivery Lists',
    Identificador: 'Identifier',
    CREADA: 'CREATED',
    EJECUTADA: 'EXECUTED',
    'Execution Date': 'Execution Date',
    Driver: 'Driver',
    Vehicle: 'Vehicle',
    'All Agency': 'All Agency',
    'All Destination': 'All Destination',
    'Delivery Comment': 'Delivery Comment',
    'Delivery Date': 'Delivery Date',
    Open: 'Open',
    Pobox: 'Pobox',
    'Arrive Date': 'Arrive date',
    'Declared Amount': 'Declared amount',
    Arrival: 'Arrival',
    Insurance: 'Insurance',
    'Other Charges': 'Other charges',
    Commission: 'Commission',
    Declared: 'Declared',
    COD: 'COD',
    'Auxiliar Date': 'Auxiliar date',
    'Shipper Email': 'Shipper email',
    'Consignee Email': 'Consignee email',
    'Package Type': 'Package type',
    'Rate Applied': 'Rate applied',
    'Fee Amount': 'Fee amount',
    Measurments: 'Measurements',
    DII: 'DII',
    'Clear Signature': 'Clear Signature',
    'Close Receipt': 'Close Receipt',
    'Mark Receipts': 'Mark Receipts',
    'as delivered': 'as delivered',
    'as undelivered': 'as undelivered',
    'Undo Ending': 'Undo Ending',
    Signature: 'Signature',
    'Take a picture': 'Take a picture',
    'Upload picture': 'Upload picture',
    'NOT ARRIVED': 'NOT ARRIVED',
    ARRIVED: 'ARRIVED',
    RECIBIDO: 'RECEIVED',
    ENVIADO_CONNECT: 'SUBMITTED BY CONNECT',
    'Create new customer': 'Create new customer',
    Customers: 'Customers',
    Multipays: 'Multipays',
    Global: 'Global',
    'POR PROCESAR': 'UNPROCESSED',
    PROCESADO: 'PROCESSED',
    Anulado: 'Void',
    Reempacado: 'Repackaged',
    Entregado: 'Delivered',
    'Balance Due': 'Balance due',
    'Deibit Credit': 'Debit/Credit',
    'An unexpected error has occurred trying to print the label, please try again':
        'An unexpected error has occurred trying to print the label, please try again',
    unexpected_error:
        'The action could not be completed. Please try again or contact the administrator.',
    'Package was not updated': 'Package was not updated',
    'Sorry, this file type is not supported':
        'Sorry, this file type is not supported',
    'Drop the file here': 'Drop the file here',
    'Drag and drop a file here, or click to select one':
        'Drag and drop a file here, or click to select one',
    'Take picture': 'Take picture',
    'Default Packages': 'Default Packages',
    'The package cannot be edited since is already processed':
        'The package cannot be edited since is already processed',
    'Create Warehouse': 'Create Warehouse',
    'Edit Shipper': 'Edit Shipper',
    'You should select a shipper before create a consignee':
        'You should select a shipper before create a consignee',
    'Edit Consignee': 'Edit Consignee',
    'Auxiliar Number': 'Auxiliar Number',
    Referencia: 'Referencia',
    PENDIENTE: 'PENDING',
    PAGADO: 'PAID',
    ANULADA: 'VOIDED',
    '': '',
    'Volumetric w.': 'Volumetric w.',
    Volumen: 'Volumen',
    'Items and Services': 'Items and Services',
    item: 'item',
    Price: 'Price',
    Qty: 'Qty',
    Total: 'Total',
    Modifiable: 'Modifiable',
    'All Bill': 'All Bill',
    Services: 'Services',
    'There are no documents to show in this view':
        'There are no documents to show in this view',
    'Upload document': 'Upload document',
    'Add Service': 'Add Service',
    'Add Item': 'Add Item',
    'Save line': 'Save line',
    'Delete line': 'Delete line',
    'Do you want to delete this package line?':
        'Do you want to delete this package line?',
    'Barcode Scanner': 'Barcode Scanner',
    'Print Label': 'Print Label',
    'Volumetric Weight': 'Volumetric Weight',
    SOLICITADO: 'REQUESTED',
    RECHAZADO: 'REJECTED',
    PROCESSED: 'PROCESSED',
    'PO Box': 'PO Box',
    Previous: 'PREVIOUS',
    Next: 'NEXT',
    Showing: 'Showing',
    items: 'items',
    'Shipping Type': 'Shipping Type',
    Requested: 'Requested',
    Rejected: 'Rejected',
    'Repacking Requests': 'Repacking Requests',
    Reject: 'Reject',
    Active: 'Active',
    Inactive: 'Inactive',
    'Create agent': 'Create agent',
    'Edit agent': 'Edit agent',
    'Identification number': 'Identification number',
    'Limit customer': 'Limit customer',
    'Edit type': 'Edit type',
    'Create type': 'Create type',
    PackType: 'Pack type',
    'Template Pack': 'Template Pack',
    'Template Packs': 'Template Packs',
    'Package details': 'Package details',
    'User Type': 'User Type',
    System: 'System',
    Manager: 'Manager',
    Agencies: 'Agencies',
    'Logistics Processes': 'Logistics Processes',
    'Manage POBox': 'Manage POBox',
    'Conversion rate': 'Conversion rate',
    'Send copy of Shipment': 'Send copy of Shipment',
    'Share your Customer': 'Share your Customer',
    'Customer editable by other agencies':
        'Customer editable by other agencies',
    'Allow Pickups': 'Allow Pickups',
    'Create agency': 'Create agency',
    'Edit agency': 'Edit agency',
    'Search customers only by Email': 'Search customers only by Email',
    'Visible from the Quote': 'Visible from the Quote',
    'Display only the address of the current agency (not all of them)':
        'Display only the address of the current agency (not all of them)',
    'Allow customization': 'Allow customization',
    'Whatsapp Image': 'Whatsapp Image',
    'Air Pobox Address': 'Air Pobox Address',
    'Sea Pobox Address': 'Maritime Pobox Address',
    'PoboxAddress tooltip': '(Include City, State, Zipcode and Country)',
    Bill: 'Bill',
    Alert: 'Alert',
    Init: 'Init',
    Profile: 'Profile',
    'Associated with': 'Associated with',
    Subject: 'Subject',
    'Title for Push notification (Mobile)':
        'Title for Push notification (Mobile)',
    'Text for Push notification (Mobile)':
        'Text for Push notification (Mobile)',
    'Sending Images': 'Sending Images',
    'Sending PDF': 'Sending PDF',
    'Body Email': 'Messages',
    'Edit body email': 'Edit body email',
    'Create body email': 'Create body email',
    Body: 'Body',
    alert_number: 'Alert Number',
    pobox_number: 'P.O. Box Number',
    consignee_description: 'Consignee Name',
    shipper_description: 'Shipper Name',
    shipment_type: 'Shipment Type',
    company_name: 'Company Name',
    name_agency: 'Agency Name',
    address_agency: 'Agency Address',
    email_agency: 'Agency Email',
    phone_agency: 'Agency Phone',
    creation_date: 'Creation Date',
    Labels: 'Labels',
    Cost: 'Cost',
    Region: 'Region',
    'Warehouse Tariff': 'Warehouse Tariff',
    'Warehouse Tariffs': 'Warehouse Tariffs',
    Range: 'Range',
    Rate: 'Rate',
    Fixed: 'Fixed',
    Tariffs: 'Tariffs',
    'Tariff type': 'Tariff Type',
    'Tariff Type': 'Tariff Type',
    'Warehouse Management': 'Warehouse Management',
    Zones: 'Zones',
    Zone: 'Zone',
    Locations: 'Locations',
    'Template Builder': 'Template Builder',

    Acronym: 'Acronym',
    'Dimensional Factor (Volumetric Weight)':
        'Dimensional Factor (Volumetric Weight)',
    'Volume Factor': 'Volume Factor',
    'TSA number': 'TSA number',
    'System Logo': 'System Logo',
    'Background image': 'Background image',
    'Billing Process': 'Billing Process',
    'Invoices paid when creating': 'Invoices paid when creating',
    'Total Rounding': 'Total Rounding',
    'Agencies can cancel invoices': 'Agencies can cancel invoices',
    'Agencies can edit invoices': 'Agencies can edit invoices',
    'By Volume': 'By Volume',
    'By Weight': 'By Weight',
    'Rounding Type': 'Rounding Type',
    Rates: 'Rates',
    'Show all rates when creating guide': 'Show all rates when creating guide',
    'Agencies can create consolidated': 'Agencies can create consolidated',
    'Assign first status automatically': 'Assign first status automatically',
    'Assign master agency to public lockers':
        'Assign master agency to public lockers',
    'Customers can edit Locker data': 'Customers can edit Locker data',
    'Create packages without measures': 'Create packages without measures',
    'Send value declaration': 'Send value declaration',
    'Repackaging of packages with Association':
        'Repackaging of packages with Association',
    'Multi-client Repackaging Request': 'Multi-client Repackaging Request',
    'Sign declaration of value': 'Sign declaration of value',
    'Note when repackaging Warehouses': 'Note when repackaging Warehouses',
    'Agency for the elements': 'Agency for the elements',
    'POBOX Address': 'POBOX Address',
    'POBOX Address 2': 'POBOX Address Auxiliary',
    'Locker Number': 'Locker Number',
    'Customer Name': 'Customer Name',
    'Module Activation': 'Module Activation',
    Quote: 'Quote',
    'Functional Activation': 'Functional Activation',
    'Custom rates (tariffs)': 'Custom rates (tariffs)',
    'Label Formats by Agency': 'Label Formats by Agency',
    'Save customer information': 'Save customer information',
    'Quotation Rates': 'Quotation Rates',
    'Social networks': 'Social networks',
    Numbers: 'Numbers',
    Prefix: 'Prefix',
    Boarding: 'Boarding',
    'Customers and Lockers use the same number':
        'Customers and Lockers use the same number',
    'Measures Units': 'Measures Units',
    'Weight Label': 'Weight Label',
    Pounds: 'Pounds',
    Kilogram: 'Kilogram',
    'Volume Label': 'Volume Label',
    'Currency Label': 'Currency Label',
    Bolivars: 'Bolivars',
    'Pound sterling': 'Pound sterling',
    'Cubic Feet': 'Cubic Feet',
    'Cubic Meters': 'Cubic Meters',
    'Commissions to agents': 'Commissions to agents',
    'Initial number per agency': 'Initial number per agency',
    'Number of decimals': 'Number of decimals',
    'Warehouse rates with cost': 'Warehouse rates with cost',
    'Rates by rank': 'Rates by rank',
    'Rates with origin and destination': 'Rates with origin and destination',
    'Automatic rate for clients': 'Automatic rate for clients',
    'Add packages to Loadunits and Consolidates':
        'Add packages to Loadunits and Consolidates',
    'Open consolidated multiple peers': 'Open consolidated multiple peers',
    'Accept repeated Trackins': 'Accept repeated Trackins',
    'Search addresses by customer': 'Search addresses by customer',
    'Email for express package': 'Email for express package',
    'Email for express Warehouse': 'Email for express Warehouse',
    'Select default recipient when selecting sender':
        'Select default recipient when selecting sender',
    'Find clients without spaces': 'Find clients without spaces',
    'Search by exact poBox number': 'Search by exact poBox number',
    'Public PoBox users are created assets':
        'Public PoBox users are created assets',
    'Mandatory Alert Tracking': 'Mandatory Alert Tracking',
    'Deployment configuration': 'Deployment configuration',
    'Update Packet Entry Settings': 'Update Packet Entry Settings',
    'Packet Input Configuration': 'Packet Input Configuration',
    'Show agency email sending': 'Show agency email sending',
    'Auxiliary label': 'Auxiliary label',
    'Update Settings': 'Update Settings',
    'Mandatory tracking': 'Mandatory tracking',
    'Mandatory value': 'Mandatory value',
    'Note Label': 'Note Label',
    'Editable from PoBox': 'Editable from PoBox',
    'Order Volume units': 'Order Volume units',
    'Dimension Unit': 'Dimension Unit',
    'Global Weight': 'Global Weight',
    'Global Volume': 'Global Volume',
    'Required Shipper': 'Required Shipper',
    'Mandatory Receiver': 'Mandatory Consignee',
    'Default Location': 'Default Location',
    'Mandatory Location': 'Mandatory Location',
    'Location Basic Data': 'Location Basic Data',
    Beginning: 'Beginning',
    End: 'End',
    'Generate Label Automatically': 'Generate Label Automatically',
    'Send Email to Sender': 'Send Email to Sender',
    'Send Email to Recipient': 'Send Email to Recipient',
    'Allow processing packets with alert':
        'Allow processing packets with alert',
    'Send Whatsapp to the Sender': 'Send Whatsapp to the Sender',
    'Send Whatsapp to the Recipient': 'Send Whatsapp to the Recipient',
    'Quick Package Options': 'Quick Package Options',
    'Agent in Quick Package': 'Agent in Quick Package',
    'Description in Quick Package': 'Description in Quick Package',
    'Clear Agency Quick Package': 'Clear Agency Quick Package',
    'Quick packet with enter check':
        'Quick packet with enter check (*requires Required Sender set to false)',
    'Show shipping type': 'Show shipping type',
    'Show Measurements': 'Show Measurements',
    'Show Carrier': 'Show Carrier',
    'Show package type': 'Show package type',
    'Shipping subtype in Repackaging': 'Shipping subtype in Repackaging',
    'Search Start Date': 'Search Start Date',
    Day: 'Day',
    Week: 'Week',
    Month: 'Month',
    Months: 'Months',
    'Arrival date': 'Arrival date',
    'Image tag': 'Image tag',
    'Mandatory Aux': 'Mandatory Aux',
    'Document label': 'Document label',
    'Description label': 'Description label',
    'Send alert email': 'Send alert email',
    'Default values': 'Default values',
    'Express Entries': 'Express Entries',
    Billing: 'Billing',
    'Dashboard Settings': 'Dashboard Settings',
    'Quick entry creation': 'Quick entry creation',
    'Package Creation': 'Package Creation',
    'Creating Alerts': 'Creating Alerts',
    'Guide Creation': 'Guide Creation',
    'Warehouse Creation': 'Warehouse Creation',
    'Creation of Consolidated': 'Creation of Consolidated',
    'Payment Creation': 'Payment Creation',
    'Quote Creation': 'Quote Creation',
    'Invoice Creation': 'Invoice Creation',
    'Client Creation': 'Client Creation',
    'Tracking Link': 'Tracking Link',
    'Pickup Creation': 'Pickup Creation',
    'Mobile App Configuration': 'Mobile App Configuration',
    'Creation of Delivery Lists': 'Creation of Delivery Lists',
    'Creation of AWB': 'Creation of AWB',
    'System Users': 'System Users',
    'PoBox Users': 'PoBox Users',
    'Creation of PoBox': 'Creation of PoBox',
    'Viewing in PoBox': 'Viewing in PoBox',
    'Guide Settings': 'Guide Settings',
    'Master Guide': 'Master Guide',
    'Master Guide Label': 'Master Guide Label',
    'Tariff Item': 'Tariff Item',
    'Exchange Rate': 'Exchange Rate',
    'Show payment COD': 'Show payment COD',
    'Assign user to the Guide': 'Assign user to the Guide',
    'Show Commission': 'Show Commission',
    'Allow creating status when finished':
        'Allow creating status when finished',
    'Request Package Type': 'Request Package Type',
    'Request Tracking': 'Request Tracking',
    'Mandatory package tracking': 'Mandatory package tracking',
    'Mandatory package value': 'Mandatory package value',
    'Content Label': 'Content Label',
    'Select client to invoice': 'Select client to invoice',
    'Bill to': 'Bill to',
    'Mandatory Agency': 'Mandatory Agency',
    'Mandatory Agent': 'Mandatory Agent',
    'Auxiliary Date': 'Auxiliary Date',
    'Auxiliary Date Label': 'Auxiliary Date Label',
    'Dangerous content option': 'Dangerous content option',
    'Show transferable option': 'Show transferable option',
    'Marked as transferable': 'Marked as transferable',
    'Updatable in consolidated form and/or with invoice':
        'Updatable in consolidated form and/or with invoice',
    'Auxiliary Text Field': 'Auxiliary Text Field',
    'Auxiliary Label': 'Auxiliary Label',
    'Label Date Auxiliary 2': 'Label Date Auxiliary 2',
    'Auxiliary Date 2 Mandatory': 'Auxiliary Date 2 Mandatory',
    'Initial Payment': 'Initial Payment',
    'Initial Payment Label': 'Initial Payment Label',
    'Numeric field that is subtracted from the total':
        'Numeric field that is subtracted from the total',
    'Label for numeric field that is subtracted from the total':
        'Label for numeric field that is subtracted from the total',
    'Assign the most recent part status to the Guide':
        'Assign the most recent part status to the Guide',
    'Calculate distance with google': 'Calculate distance with google',
    'Avoid Highways': 'Avoid Highways',
    'Avoid Tolls': 'Avoid Tolls',
    Additional: 'Additional',
    finishAllPackages:
        'Upon completion, all extracted and unextracted packages will inherit the finished status in the guide.',
    'Chargeable volume': 'Chargeable volume',
    'Loadable Volume Value': 'Loadable Volume Value',
    'Just basic data': 'Just basic data',
    'Bill on creation': 'Bill on creation',
    'Default Services': 'Default Services',
    'Agency for delivery notes': 'Agency for delivery notes',
    'Copy of creation emails': 'Copy of creation emails',
    'Copy of Email to': 'Copy of Email to',
    'Quick Warehouse Options': 'Quick Warehouse Options',
    'Agent at Rapid Warehouse': 'Agent at Rapid Warehouse',
    'Description in Quick Warehouse': 'Description in Quick Warehouse',
    'Clear Agency Warehouse Fast': 'Clear Agency Warehouse Fast',
    'Quick Warehouse with enter control': 'Quick Warehouse with enter control',
    'Need Sender Required in false': 'Need Sender Required in false',
    'Days to send': 'Days to send',
    Repacking: 'Repacking',
    Searches: 'Searches',
    Document_Description: 'Manage, search, labels, reports, and more',
    Searches_Description: 'Quickly find items by search criteria.',
    Transporters: 'Transporters',
    WAREHOUSE: 'WAREHOUSE',
    RECEPTION: 'RECEPTION',
    CONTROL: 'CONTROL',
    ANOTHER: 'ANOTHER',
    ANULADO: 'VOIDED',
    REEMPACADO: 'REPACKAGED',
    'Terms & Conditions': 'Terms & Conditions',
    'Declared Value': 'Declared Value',
    None: 'None',
    'Include items without recipient': 'Include items without recipient',
    'Required City': 'Required City',
    'Sender and Recipient can be the same':
        'Sender and Recipient can be the same',
    'Update even if you have items': 'Update even if you have items',
    'Generate Zip': 'Generate Zip',
    'Auxiliar Label Date': 'Auxiliar Label Date',
    'City Label': 'City Label',
    'Mandatory Auxiliar Date': 'Mandatory Auxiliar Date',
    'Auxiliar Label': 'Auxiliar Label',
    'Required Auxiliar 2': 'Required Auxiliar 2',
    'Mandatory Auxiliar': 'Mandatory Auxiliar',
    'Auxiliar Label 2': 'Auxiliar Label 2',
    'Document Label': 'Document Label',
    'Mandatory Document': 'Mandatory Document',
    'Audit Extra': 'Audit Extra',
    'Mandatory Audit Extra': 'Mandatory Audit Extra',
    'Audit Extra Label': 'Audit Extra Label',
    'Required Auxiliar': 'Required Auxiliar',
    'Tax Label': 'Tax Label',
    'Show approximation options': 'Show approximation options',
    'Auxiliary numeric number': 'Auxiliary numeric number',
    'Label for auxiliary numerical number':
        'Label for auxiliary numerical number',
    'Default value': 'Default value',
    'Mandatory Currency': 'Mandatory Currency',
    'Identity Document': 'Identity Document',
    Label: 'Label',
    'Tariff Group': 'Tariff Group',
    'Value Document ID': 'Value Document ID',
    Assistant: 'Assistant',
    'Assistant Label': 'Assistant Label',
    'Client Class': 'Client Class',
    'Customer Type Label': 'Customer Type Label',
    'Mandatory Customer Type': 'Mandatory Customer Type',
    'Customer Type Options': 'Customer Type Options',
    'Assistant Date': 'Assistant Date',
    'Automatically assign the corresponding agent in logistics operations':
        'Automatically assign the corresponding agent in logistics operations',
    'Assistant Date Label': 'Assistant Date Label',
    'Assistant Date Mandatory': 'Assistant Date Mandatory',
    'Location Mandatory': 'Location Mandatory',
    'Mobile Mandatory': 'Mobile Mandatory',
    'Document ID Mandatory': 'Document ID Mandatory',
    'Non-repeated Email': 'Non-repeated Email',
    'Assistant Date 1': 'Assistant Date 1',
    'Assistant Label 1': 'Assistant Label 1',
    'Mandatory Assistant 1': 'Mandatory Assistant 1',
    'Assistant 2': 'Assistant 2',
    'Assistant Label 2': 'Assistant Label 2',
    'Mandatory Assistant 2': 'Mandatory Assistant 2',
    'Non-repeated identity document': 'Non-repeated identity document',
    'Auto Required Pickup': 'Auto Required Pickup',
    'Show Sub Text': 'Show Sub Text',
    'Public Search': 'Public Search',
    'Auxiliar Text 1': 'Auxiliar Text 1',
    'Auxiliar Text 2': 'Auxiliar Text 2',
    'Auxiliar Text 3': 'Auxiliar Text 3',
    'Auxiliar Text 4': 'Auxiliar Text 4',
    'Auxiliar Text 5': 'Auxiliar Text 5',
    'Required Expire Date': 'Required Expire Date',
    'Expire Date': 'Expire Date',
    'Weight Unit': 'Unidad de peso',
    Accounting: 'Accounting',
    Dash: 'Dash',
    'Pack New': 'Pack New',
    'Pack New Fast': 'Pack New Fast',
    'Pack List': 'Pack List',
    'Pack Manage': 'Pack Manage',
    'Pack New Prepack': 'Pack New Prepack',
    'Pack List Prepack': 'Pack List Prepack',
    'Pack Sys Receipt': 'Pack Sys Receipt',
    'WH Rec New': 'WH Rec New',
    'WH Rec List': 'WH Rec List',
    'WH Rec Manage': 'WH Rec Manage',
    'WH Rec In WR': 'WH Rec In WR',
    'WH Rec Search': 'WH Rec Search',
    'WH Rec Sys Receipt': 'WH Rec Sys Receipt',
    'Guide New': 'Guide New',
    'Guide List': 'Guide List',
    'Guide Search': 'Guide Search',
    'Guide for Pack': 'Guide for Pack',
    'Guide to Consol': 'Guide to Consol',
    'Bag List': 'Bag List',
    'Bag New': 'Bag New',
    'Bag Receive': 'Bag Receive',
    'Bag to Consol': 'Bag to Consol',
    'Load Unit New': 'Load Unit New',
    'Load Unit List': 'Load Unit List',
    'Consol New': 'Consol New',
    'Consol List': 'Consol List',
    'Consol Ship New': 'Consol Ship New',
    'Consol Ship List': 'Consol Ship List',
    Bills: 'Bills',
    Graphs: 'Graphs',
    Guides: 'Guides',
    'Track Packages': 'Track Packages',
    'Repack Request': 'Repack Request',
    'Repack Tracking': 'Repack Tracking',
    'Repack Packages': 'Repack Packages',
    'Repack Warehouse': 'Repack Warehouse',
    'Bill Warehouse': 'Bill Warehouse',
    'Bill Guides': 'Bill Guides',
    'Pay Methods': 'Pay Methods',
    'Pay Notify': 'Pay Notify',
    'Pay Customer': 'Pay Customer',
    'Pay Customer Unverified': 'Pay Customer Unverified',
    'Are you sure you want to remove this status?':
        'Are you sure you want to remove this status?',
    Accounts: 'Accounts',
    'Show PO Boxes': 'Show PO Boxes',
    'Show Data': 'Show Data',
    'Update Data': 'Update Data',
    'HTML Code': 'HTML Code',
    'HTML Head': 'HTML Head',
    'Pobox Address': 'Pobox Address',
    'To send online purchases, commercial shipments, or packages:':
        'To send online purchases, commercial shipments, or packages:',
    'To any of these addresses:': 'To any of these addresses:',
    'Select at least one item to send': 'Select at least one item to send',
    required_field: 'The field "{field}" is required to create a package.',
    'You cannot repack a package that has already been processed':
        'You cannot repack a package that has already been processed',
    'Please add at least one package': 'Please add at least one package',
    'Sea Ports': 'Sea Ports',
    'Email setup': 'Email setup',
    'Pack Types': 'Pack Types',
    'Paid Types': 'Paid Types',
    'Shipment rate': 'Shipment rate',
    'Warehouse rate': 'Warehouse rate',
    Carriers: 'Carriers',
    Vehicles: 'Vehicles',
    Branches: 'Branches',
    PoBOX: 'PO Box',
    'WareHouse Rate': 'Warehouse Rate',
    Flat: 'Flat',
    Distance: 'Distance',
    'Region Filter': 'Region Filter',
    'Calculation Method': 'Calculation Method',
    'Editable Price': 'Editable Price',
    'Visible in the Quote': 'Visible in the Quote',
    'Lower Limit': 'Lower Limit',
    'Value to Pay': 'Value to Pay',
    'Additional Label': 'Additional Label',
    flat: 'Flat',
    range: 'Range',
    pieces: 'Pieces',
    volume: 'Volume',
    weight: 'Weight',
    AllAgencies: 'All Agencies',
    'Rate type': 'Rate type',
    'Shipment Rate': 'Shipment Rate',
    'Upper Limit': 'Upper Limit',
    Profit: 'Profit',
    'Insurance Percentage': 'Insurance Percentage',
    'Tax Percentage': 'Tax Percentage',
    'Minimum Charge': 'Minimum Charge',
    'Minimun Limit': 'Minimun Limit',
    Individual: 'Individual',
    'Minimum Price': 'Minimum Price',
    'Rate Ranges': 'Rate Ranges',
    Minimum: 'Minimum',
    Maximum: 'Maximum',
    'Minimum limit in units of measurement':
        'Minimum limit in units of measurement',
    Reopen: 'Reopen',
    'Send Notification': 'Send Notification',
    Clear: 'Clear',
    'Accept and sign': 'Accept and sign',
    Warehouse: 'Warehouse',
    'Repack in Warehouse': 'Repack in Warehouse',
    Repack: 'Repack',
    'Receipt List': 'Receipt List',
    'Warehouse List': 'Warehouse List',
    LoadUnits: 'Load Units',
    'Email Setup': 'Email Setup',
    Service: 'Service',
    Item: 'Item',
    'Unit Measure': 'Unit Measure',
    'Unit Price': 'Unit Price',
    Discount: 'Discount',
    'Shipment List': 'Shipment List',
    'LoadUnit List': 'LoadUnit List',
    'Alternative name': 'Alternative name',
    'Add package': 'Add package',
    'Add Warehouse Receipt': 'Add Warehouse Receipt',
    'Add Warehouse': 'Add Warehouse Receipt',
    'Add Shipment': 'Add Shipment',
    'Add LoadUnit': 'Add LoadUnit',
    'Export to Excel': 'Export to Excel',
    'Export to PDF': 'Export to PDF',
    'Export to CSV': 'Export to CSV',
    'Save & Close': 'Save & Close',
    'Exit without saving': 'Exit without saving',
    'Are you sure you want to exit without saving?':
        'Are you sure you want to exit without saving?',
    ACTIVO: 'ACTIVE',
    'Invalid email': 'Invalid email',
    'Press Enter or comma to add. Use Backspace to remove.':
        'Press Enter or comma to add. Use Backspace to remove.',
    'Search by number (shipper, warehouse), email, name':
        'Search by number (shipper, warehouse), email, name',
    'The following items are already repacked: {numbers}':
        'The following items are already repacked: {numbers}',
    'Label configuration': 'Label configuration',
    'Search by number (shipper, package, pobox), email, name':
        'Search by number (shipper, package, pobox), email, name',
    'Search by number': 'Search by number',
    'Search by tracking': 'Search by tracking',
    'Search by number (shipper, pobox), email, name.':
        'Search by number (shipper, pobox), email, name',
    'Search by number, customer number, email, name':
        'Search by number, customer number, email, name',
    'Search by number, customer number': 'Search by number, customer number',
    'Search by email, name': 'Search by email, name',
    'Search by name': 'Search by name',
    isDefault: 'Is Default',
    'Margin Top': 'Margin Top',
    'Margin Bottom': 'Margin Bottom',
    'Margin Left': 'Margin Left',
    'Margin Right': 'Margin Right',
    Processing: 'Process',
    whrec: 'Warehouse',
    guide: 'Guide',
    receipt: 'Package',
    'Repacking type': 'Request type',
    'Create Alert': 'Create Alert',
    'Processed by': 'Processed by',

    'Agency name': 'Agency name',
    'Agency Address': 'Agency Address',
    'Agency City': 'Agency City',
    'Agency Zip': 'Agency Zip',
    'Agency Phone': 'Agency Phone',
    'Agency Email': 'Agency Email',
    'Destination agency name': 'Destination agency name',
    'Destination agency address': 'Destination agency address',
    'Destination agency Zip': 'Destination agency Zip',
    'Destination agency Phone': 'Destination agency Phone',
    'Destination agency Email': 'Destination agency Email',

    'Consignee data': 'Consignee',
    'Consignee name': 'Consignee name',
    'Consignee Address': 'Consignee Address',
    'Consignee City': 'Consignee City',
    'Consignee Zip': 'Consignee Zip',
    'Consignee Phone': 'Consignee Phone',
    'Consignee Mobile': 'Consignee Mobile',
    'Consignee PoBOX': 'Consignee PoBOX',
    'Consignee Number': 'Consignee Number',
    'Consignee Country': 'Consignee Country',
    'Consignee Full Address': 'Consignee Full Address',
    'COD Consignee City': 'COD Consignee City',
    'Consignee DocID': 'Consignee DocID',
    'Consignee CD State ZIP': 'Consignee CD State ZIP',
    'Location for consignee': 'Location for consignee',
    'Consignee Agency': 'Consignee Agency',
    'Packages warehouse consignee': 'Packages warehouse consignee',

    'Shipper data': 'Shipper',
    'Shipper name': 'Shipper name',
    'Shipper Address': 'Shipper Address',
    'Shipper City': 'Shipper City',
    'Shipper Zip': 'Shipper Zip',
    'Shipper Phone': 'Shipper Phone',
    'Shipper Mobile': 'Shipper Mobile',
    'Shipper PoBOX': 'Shipper PoBOX',
    'Shipper Number': 'Shipper Number',
    'Shipper Country': 'Shipper Country',
    'Shipper Full Address': 'Shipper Full Address',
    'COD Shipper City': 'COD Shipper City',
    'Shipper DocID': 'Shipper DocID',
    'Shipper CD State ZIP': 'Shipper CD State ZIP',
    'Location for shipper': 'Location for shipper',
    'Shipper Agency': 'Shipper Agency',
    'Packages warehouse shipper': 'Packages warehouse shipper',

    'Receipt Number': 'Receipt Number',
    'Receipt Date': 'Receipt Date',
    'Receipt Carrier': 'Receipt Carrier',
    'Receipt Type': 'Receipt Type',
    'Receipt ShippingType': 'Receipt ShippingType',
    'Receipt Description': 'Receipt Description',
    'Receipt Tracking': 'Receipt Tracking',
    'Receipt Value': 'Receipt Value',
    'Receipt Height': 'Receipt Height',
    'Receipt Width': 'Receipt Width',
    'Receipt Volume': 'Receipt Volume',
    'Receipt Pieces': 'Receipt Pieces',
    'Receipt Weight': 'Receipt Weight',
    'Receipt Volume Weight': 'Receipt Volume Weight',
    'Receipt COD': 'Receipt COD',
    'Receipt COD Tracking': 'Receipt COD Tracking',
    'Receipt COD Unit': 'Receipt COD Unit',
    'Receipt Unit Volume': 'Receipt Unit Volume',
    'Receipt Note': 'Receipt Note',
    'Receipt Agent': 'Receipt Agent',
    'Receipt Location': 'Receipt Location',
    'QR Package with Unit': 'QR Package with Unit',
    'QR Package Tracking': 'QR Package Tracking',
    'QR Warehouse Receipt': 'QR Warehouse Receipt',
    'QR Guide': 'QR Guide',

    'Shipment Number': 'Shipment Number',
    'Total shipment price': 'Total shipment price',
    'Shipment Date': 'Shipment Date',
    'Shipment insured amount': 'Shipment insured amount',
    'Sending a Shipment': 'Sending a Shipment',
    'Declared shipment value': 'Declared shipment value',
    'Master shipment': 'Master shipment',
    'Tariff shipment heading': 'Tariff shipment heading',
    'Date and time of shipment': 'Date and time of shipment',
    'Pickup Guide Number': 'Pickup Guide Number',
    'Pickup Guide Route': 'Pickup Guide Route',
    'Shipment delivery route': 'Shipment delivery route',
    'AWB Number': 'AWB Number',
    'COD Payment': 'COD Payment',
    'Auxiliary Date 2': 'Auxiliary Date 2',
    'Dangerous Content': 'Dangerous Content',
    'Auxiliary Text': 'Auxiliary Text',
    'Down payment': 'Down payment',
    'Down payment 2': 'Down payment 2',
    'Payment general tax': 'Payment general tax',
    'Tariff tax': 'Tariff tax',
    'Payment type': 'Payment type',
    'Freight tax': 'Freight tax',

    'Warehouse Number': 'Warehouse Number',
    'Warehouse Date': 'Warehouse Date',
    'Warehouse note': 'Warehouse note',
    'Warehouse INS': 'Warehouse INS',
    'Pickup Warehouse Number': 'Pickup Warehouse Number',
    'Pickup Warehouse Route': 'Pickup Warehouse Route',
    'Warehouse delivery route': 'Warehouse delivery route',
    'Warehouse Aux': 'Warehouse Aux',
    'Warehouse AWB number': 'Warehouse AWB number',
    'Consolidated Number': 'Consolidated Number',
    'Consolidated Alt. Name': 'Consolidated Alt. Name',
    'Load Unit Number': 'Load Unit Number',
    'Cod Auxiliary': 'Cod Auxiliary',
    'Invoice number': 'Invoice number',

    'LoadUnit Number': 'LoadUnit Number',
    'LoadUnit Date': 'LoadUnit Date',
    'LoadUnit note': 'LoadUnit note',
    'LoadUnit Shipping': 'LoadUnit Shipping',
    'LoadUnit Origin Country': 'LoadUnit Origin Country',
    'LoadUnit Destination Country': 'LoadUnit Destination Country',
    'Total weight of LoadUnit': 'Total weight of LoadUnit',
    'Total volume of LoadUnit': 'Total volume of LoadUnit',
    'Total volumetric weight': 'Total volumetric weight',
    'Total pieces': 'Total pieces',
    'Weight pieces': 'Weight pieces',
    'Volume pieces': 'Volume pieces',
    'Unit pieces': 'Unit pieces',

    'Arrival Date': 'Arrival Date',
    'Auxiliary Field': 'Auxiliary Field',

    'Commodity Number': 'Commodity Number',
    'Commodity measures': 'Commodity measures',
    'Commodity pieces': 'Commodity pieces',
    'Commodity weight': 'Commodity weight',
    'AWB destination airport': 'AWB destination airport',
    'AWB destination city': 'AWB destination city',
    'AWB destination country': 'AWB destination country',
    'Guide number house': 'Guide number house',
    'Pieces number house': 'Pieces number house',
    'Number of guides house': 'Number of guides house',
    'Departure airport': 'Departure airport',

    Collection: 'Collection',
    'Collection Name': 'Collection Name',
    'Collection Address': 'Collection Address',
    'Collection Email': 'Collection Email',
    'Collection City': 'Collection City',
    'Collection Zip': 'Collection Zip',
    'Collection Phone': 'Collection Phone',
    'Collection Mobile': 'Collection Mobile',
    'Collection PoBox': 'Collection PoBox',
    'Collection Number': 'Collection Number',
    'Collection Country': 'Collection Country',
    'Collection State': 'Collection State',
    'Collection full address': 'Collection full address',
    'COD Collection city': 'COD Collection city',
    'Collection docId': 'Collection docId',
    'Collection location': 'Collection location',
    'Collection agency': 'Collection agency',

    'Delivery Name': 'Delivery Name',
    'Delivery Email': 'Delivery Email',
    'Delivery City': 'Delivery City',
    'Delivery Zip': 'Delivery Zip',
    'Delivery Phone': 'Delivery Phone',
    'Delivery Mobile': 'Delivery Mobile',
    'Delivery PoBox': 'Delivery PoBox',
    'Delivery Number': 'Delivery Number',
    'Delivery Country': 'Delivery Country',
    'Delivery State': 'Delivery State',
    'Delivery full address': 'Delivery full address',
    'COD Delivery city': 'COD Delivery city',
    'Delivery docId': 'Delivery docId',
    'Delivery location': 'Delivery location',
    'Delivery agency': 'Delivery agency',

    'Customer Email': 'Customer Email',
    'Customer City': 'Customer City',
    'Customer Zip': 'Customer Zip',
    'Customer Phone': 'Customer Phone',
    'Customer Mobile': 'Customer Mobile',
    'Customer PoBox': 'Customer PoBox',
    'Customer Number': 'Customer Number',
    'Customer Country': 'Customer Country',
    'Customer State': 'Customer State',
    'Customer full address': 'Customer full address',
    'COD Customer city': 'COD Customer city',
    'Customer docId': 'Customer docId',
    'Customer location': 'Customer location',
    'Customer agency': 'Customer agency',

    'Pickup Number': 'Pickup Number',
    'Pickup hour range': 'Pickup hour range',
    'Pickup payment type': 'Pickup payment type',
    'Pickup shipment type': 'Pickup shipment type',
    'Pickup note': 'Pickup note',

    'Sending Office': 'Sending Office',
    'Current agency': 'Current agency',
    'Country of origin': 'Country of origin',
    'Receiving office': 'Receiving office',
    'Country of destination': 'Country of destination',
    'Auxiliary 1': 'Auxiliary 1',
    'Auxiliary 2': 'Auxiliary 2',
    'Total Pieces': 'Total Pieces',
    'Total Packages': 'Total Packages',
    'Total Shipments': 'Total Shipments',
    'Total Warehouse Receipts': 'Total Warehouse Receipts',
    'Total Load Units': 'Total Load Units',
    'Total weight': 'Total weight',
    'Total volume': 'Total volume',
    'Total valor': 'Total valor',
    'Total guide weight': 'Total guide weight',
    QR: 'QR',
    'Invoice cancelled.': 'Invoice cancelled.',

    // Reports
    'reports.error.generate': 'Error generating report',
    'Print.label': 'Label',
    'Print.delivery.note': 'Delivery Note',
    'Print.shippers.declaration': 'Shippers Declaration',

    'Confirm clear format': 'Do you want to clear the format?',
    'Cannot save a label without elements.':
        'Cannot save a label without elements.',
    lineh: 'Line Height',
    linev: 'Line Vertical',
    Position: 'Position',
    Size: 'Size',
    Margins: 'Margins',
    Canvas: 'Canvas',
    Styles: 'Styles',
    Logo: 'Logo',
    Verified: 'Verified',
    Verify: 'Verify',
    'Verify Payment': 'Verify Payment',
    'Not Verified': 'Not Verified',
    'Invoice Number': 'Invoice Number',

    // Error handling translations
    'saving invoice': 'saving invoice',
    'removing item': 'removing item',
    'deleting payment': 'deleting payment',
    'An error occurred while {operation}':
        'An error occurred while {operation}',
    'Error {operation}: {errorMsg}': 'Error {operation}: {errorMsg}',

    shipper_name: 'Shipper name',
    receiver_name: 'Consignee name',
    description: 'Details',
    instruction: 'Shipping type',

    agency_name: 'Agency name',
    agency_address: 'Agency address',
    agency_email: 'Agency email',
    agency_phone: 'Agency phone',

    link_pobox: 'Pobox link',
    link_tracking: 'Tracking link',
    link_company: 'Company link',
    change_instruction_link: 'Change shipping type',
    link_signature: 'Signature link',
    link_locker: 'Locker link',

    receiver_fullname: 'Consignee full name',
    receiver_address: 'Consignee address',
    receiver_pobox: 'Consignee pobox',
    receiver_mobile: 'Consignee mobile',
    receiver_country: 'Consignee country',
    receiver_state: 'Consignee state',
    receiver_docid: 'Consignee document',

    shipper_fullname: 'Shipper full name',
    shipper_address: 'Shipper address',
    shipper_pobox: 'Shipper pobox',
    shipper_mobile: 'Shipper mobile',
    shipper_country: 'Shipper country',
    shipper_state: 'Shipper state',
    shipper_docid: 'Shipper document',
    'Document ID': 'Document ID',
    'City, State, Zip Code': 'City, State, Zip Code',
    'Phone, Mobile': 'Phone, Mobile',

    note: 'Note',
    aux: 'Reference',

    customer_name: 'Customer name',
    customer_lastname: 'Customer lastname',
    customer_address: 'Customer address',
    customer_city: 'Customer city',
    customer_state: 'Customer state',
    customer_country: 'Customer country',
    customer_email: 'Customer email',
    customer_mobile: 'Customer mobile',
    customer_phone: 'Customer phone',
    customer_pobox: 'Customer pobox',
    customer_number: 'Customer number',

    element_type: 'Element type',
    location_code: 'Location code',
    agent_fullname: 'Agent name',

    total_pieces: 'Total pieces',
    total_weight: 'Total weight',
    total_volume: 'Total volume',

    sender_name: 'Sender name',
    addressee_name: 'Addressee name',
    contain: 'Content',
    shipping_type: 'Shipping type',

    agent_name: 'Agent name',

    master_guide: 'Master guide',
    details: 'Details',

    sender: 'Sender',
    receiver: 'Consignee',

    guide_number: 'Guide number',
    status_date: 'Status date',
    status_comment: 'Status comment',
    request_date: 'Request date',
    destination_city: 'Destination city',
    package_details: 'Package details',

    warehouse_number: 'Warehouse number',
    status_city: 'Status city',
    status_type: 'Status type',

    pobox_username: 'Pobox Username',

    paid_amount: 'Paid amount',
    unpaid_amount: 'Unpaid amount',
    stripe_payment_link: 'Stripe Payment Link',
    invoice_total: 'Invoice Total',
    invoice_number: 'Invoice Number',

    pickup_number: 'Pickup Number',
    pickup_date: 'Pickup Date',
    pickup_hours: 'Pickup Hours',
    pickup_payment_type: 'Pickup Payment Type',
    pickup_shipping_type: 'Pickup Shipping Type',
    pickup_note: 'Pickup Note',
    operation_type: 'Operation Type',

    pickup_name: 'Pickup Name',
    pickup_address: 'Pickup Address',
    pickup_phone: 'Pickup Phone',
    pickup_mobile: 'Pickup Mobile',
    pickup_email: 'Pickup Email',

    delivery_name: 'Delivery Name',
    delivery_address: 'Delivery Address',
    delivery_phone: 'Delivery Phone',
    delivery_mobile: 'Delivery Mobile',
    delivery_email: 'Delivery Email',

    'You have unsaved changes. Do you want to exit anyway?':
        'You have unsaved changes. Do you want to exit anyway?',
    Spanish: 'Spanish',
    English: 'English',
    Language: 'Language',
    Action: 'Action',
    'New Invoice': 'New Invoice',
    'New Customer': 'New Customer',
    'New Warehouse': 'New Warehouse',
    'New Shipment': 'New Shipment',
    'New Package': 'New Package',
    'New Pickup': 'New Pickup',
    'Status Change': 'Status Change',
    Completation: 'Completion',
    'New QInvoice': 'New QInvoice',

    // Customer translations
    'Create Customer': 'Create Customer',
    'Edit Customer': 'Edit Customer',
    'Customer Addresses': 'Customer Addresses',
    'Error loading addresses': 'Error loading addresses',
    'Error saving customer': 'Error saving customer',
    'Error loading address': 'Error loading address',
    'Error creating address': 'Error creating address',
    'Error updating address': 'Error updating address',
    'Edit Address': 'Edit Address',
    'Create Address': 'Create Address',

    // Form section titles
    Emails: 'Emails',

    address: {
        delete: {
            title: 'Delete Address',
            message: 'Are you sure you want to delete this address?',
            success: 'Address deleted successfully'
        },
        save: {
            success: 'Address saved successfully'
        },
        validation: {
            customerRequired: 'Must save customer first'
        }
    },

    // Print label error messages
    'Unsupported entity type for label printing':
        'Unsupported entity type for label printing',
    'Invalid entity ID for label printing':
        'Invalid entity ID for label printing',
    'Error generating label': 'Error generating label',
    'No Category': 'No Category',
    Quotes: 'Quotes',
    'List Quotes': 'List Quotes',
    Information: 'Information',
    'Welcome Dashboard': 'Welcome Dashboard',
    'You do not have permission to view': 'You do not have permission to view',

    // Registration
    'Create your locker': 'Create your locker',
    'Registering a locker is fast and free - without commitments or contracts.':
        'Registering a locker is fast and free - without commitments or contracts.',
    'Account type': 'Account type',
    Person: 'Person',
    'Personal information': 'Personal information',
    'Last name': 'Last name',
    'Identity document': 'Identity document',
    'Search City': 'Search City',
    'Account credentials': 'Account credentials',
    'Repeat Email': 'Repeat Email',
    'Repeat Password': 'Repeat Password',
    'Create Locker': 'Create Locker',
    'Already have an account?': 'Already have an account?',
    'Sign in here': 'Sign in here',
    "Don't have an account?": "Don't have an account?",
    'Create your locker here': 'Create your locker here',
    'Name is required': 'Name is required',
    'Name must be at least 2 characters': 'Name must be at least 2 characters',
    'Mobile is required': 'Mobile is required',
    'Invalid phone format': 'Invalid phone format',
    'Address is required': 'Address is required',
    'Address must be at least 10 characters':
        'Address must be at least 10 characters',
    'City is required': 'City is required',
    'Email is required': 'Email is required',
    'Invalid email format': 'Invalid email format',
    'Repeat email is required': 'Repeat email is required',
    'Emails do not match': 'Emails do not match',
    'Password must be at least 6 characters':
        'Password must be at least 6 characters',
    'Repeat password is required': 'Repeat password is required',
    'Passwords do not match': 'Passwords do not match',
    'I agree to the terms and conditions':
        'I agree to the terms and conditions',
    'I agree to the': 'I agree to the',
    'Terms and conditions': 'Terms and conditions',
    'reCAPTCHA verification failed': 'reCAPTCHA verification failed',
    'Please complete the reCAPTCHA verification':
        'Please complete the reCAPTCHA verification',
    'You must accept the terms and conditions':
        'You must accept the terms and conditions',
    'Enter phone number': 'Enter phone number',
    '0.5 superior': '0.5 upper',
    'Entero superior': 'Whole upper',
    COBRADA: 'PAID',

    'Entero mas cercano': 'Nearest whole',
    'Redondeo condicional >=0.5 al entero superior':
        'Conditional rounding >=0.5 to upper whole',
    twilio_actions: {
        new_invoice: 'New Invoice',
        new_customer: 'New Customer',
        new_warehouse: 'New Warehouse Receipt',
        new_guide: 'New Shipment',
        new_package: 'New Package',
        new_pickup: 'New Pickup',
        status_change: 'Status Change',
        completation: 'Completation',
        new_qinvoice: 'New QInvoice'
    },
    'Generated by': 'Generated by',
    'Receiver Pobox': 'Consignee Pobox',
    'Info Auxiliary': 'Info Auxiliary',
    no_entities_to_repack:
        'There are no packages or warehouse receipts available to process this repack request.',
    'Search By Tracking': 'Search By Tracking',
    'Search By Number': 'Search By Number',
    'Search By Email': 'Search By Email',
    'Search By Name': 'Search By Name',
    'Search By POBox': 'Search By POBox',
    'Pickup Information': 'Pickup Information',
    'Delivery Information': 'Delivery Information',
    'Address Line 2': 'Address Line 2',
    'Deliver to agency': 'Deliver to agency',
    globalSearch: {
        byPackageTracking: 'Package Tracking',
        byPackageDescription: 'Package Description',
        byPackageNumber: 'Package Number',
        byWarehouseReceiptNumber: 'Warehouse Receipt Number',
        byShipmentNumber: 'Shipment Number',
        byInvoiceNumber: 'Invoice Number',
        byCustomerInfo: 'Customer'
    },
    'Shipping Requests': 'Shipping Requests',
    'Are you sure you want to verify this payment?':
        'Are you sure you want to verify this payment?',
    'Add Services': 'Add Services',
    'Tax Amount': 'Tax Amount',
    'Item Type': 'Item Type',
    'Item Number': 'Item Number',
    'My Info': 'My info',
    'Scheduled for': 'Scheduled for',
    Abierta: 'Opened',
    Cerrada: 'Closed',
    Opened: 'Opened',
    Closed: 'Closed',
    'Routes Pickups': 'Routes Pickups',
    'Pickups List': 'Pickups List',
    'Add pickups from any agency': 'Add pickups from any agency',
    'Actualizar Paquetes': 'Update Packages',
    'Consolidar en Guía': 'Consolidate in Shipment',
    'Consolidar en Whrec': 'Consolidate in Whrec',
    'Procesado en': 'Processed in',
    Correlative: 'Correlative',
    'Correlative Numbers': 'Correlative Numbers',
    'Correlatie Types': 'Correlatie Types',
    'Document Type': 'Document Type',
    'Last Number': 'Last Number',
    'Last Update': 'Last Update',
    'No more items': 'No more items',
    Routes: 'Routes',
    timeRange: '"To" time must be later than "From" time',
    'Invalid session. Please complete your payment first.':
        'Invalid session. Please complete your payment first.',
    'The session is not correct.': 'The session is not correct.',
    'Error verifying session. Please try again.':
        'Error verifying session. Please try again.',
    'Public Links': 'Public Links',
    'Cargo Verification': 'Cargo Verification',
    'List consolchecks': 'List consolchecks',
    'Create consolcheck': 'Create consolcheck',
    Numbering: 'Numbering'
};
